import { useEffect, useState } from 'react';
import { applyBlur, notifyPageConcealed } from './invigilate-blur';

export const useTabChange = () => {
  const [tabMoveCount, setTabMoveCount] = useState(0);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden') {
        notifyPageConcealed();
        setTabMoveCount((preState) => preState + 1);
      } else {
        applyBlur();
        console.log('Tab is visible');
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  return { tabMoveCount };
};
